<!-- 套餐详情页面 -->

<template>
    <div class="package-detail">
        <div class="package-detail-header">
            <app-header            
                @on-click="goBack"
                :title="$t('packages.confirm.title')"
            ></app-header>
        </div>
        <div class="package-detail-box">
            <div class="package-base-info">
                <div class="goods-name">{{ detail.goodsName }}</div>
                <div class="goods-price" v-if="$route.query.promotionCode">{{ detail.oringPrice ? doPriceStyle(detail, detail.oringPrice) : detail.showPrice }}</div>
                <div class="goods-price" 
                v-else-if="detail.firstPrice">{{detail.firstShowPrice}}<i class="oprice"> {{ doPriceStyle(detail, detail.oringPrice) }}</i></div>
                <div class="goods-price" 
                v-else-if="detail.oringPrice">{{detail.showPrice}}<i class="oprice"> {{ doPriceStyle(detail, detail.oringPrice) }}</i></div>
                <div class="goods-price" v-else>{{detail.showPrice }}</div>
                <div class="info-box van-hairline--top">
                    <!-- saas-隐藏流量-配置 -->
                    <van-cell :title="$t('packages.detail.cell_flow')" 
                    value-class="flex2"
                    v-if="!detail.extendValVos || !detail.a_getValue_hideFlowSize || detail.a_getValue_hideFlowSize && detail.a_getValue_hideFlowSize != '1' ">
                            <span>{{detail.showFlow}}</span>
                            <!-- <i v-if="detail.periodStr">/{{ detail.periodStr }}</i> -->
                    </van-cell>
                    
                    <!-- 老业务逻辑展示套餐周期 -->
                    <!-- <van-cell v-if="detail.period" :title="$t('packages.detail.cell_period')" :value="detail.periodText"></van-cell> -->
                    <!-- 连续畅享  展示套餐周期 -->
                    <van-cell value-class="flex2" v-if="detail.showPeriod" :title="$t('packages.detail.cell_period')" :value="detail.showPeriod"></van-cell>
                </div>
            </div>

            <div class="package-choose-option se_package_option" v-if="continue_html">
                 <div class="continue_mo" :class="{ 'active': continuePkgData.select}" v-html="this.continue_html" @click="swithPkg(0,continuePkgData)"> </div>
                <div class="payAgreeSymbol_wrap_agreement" v-show="CheckautopayRegulation.payAgreeSymbol_wrap">
                    <p>{{$t('settlement_Read')}}  “<a :href="CheckautopayRegulation.url"  target="_blank" >{{$t('settlement_Autopay_service_regulation')}}</a>”</p>
                </div>
                 <div class="normal_mo" v-for="npkg in normalPkgDataList" :key="npkg.goodsId" :class="{ 'active': npkg.select}"  @click="swithPkg(1,npkg)">
                     <p class="se_title">{{npkg.goodsName}}</p>
                      <p class="se_package_price">
                        {{npkg.showPrice}} 
                      </p>
                 </div>
            </div>

            <div class="package-show-promotion" v-if="detail.show_Promotion">
                <div class="box-title">{{ $t('packages_detail_promotion') }}<i class="icon_more" @click="showPromotionPopup = true">...</i></div>
                <div class="package-desc" v-for="(item, index) in detail.PromotionValue" :key="index" @click="selectPromotion()">
                    <van-cell :icon="item.show_Promotion_icon + ' iconSize' " :value-class="isCurrencySymbol(packageData.currencyType) ? '' : 'arValue'" :title="item.show_Promotion_name" :value="Promotion_use_discount"></van-cell>
                    <p v-if="Module_Coupon && Promotion_use_discount && !CheckautopayRegulation.payAgreeSymbol_wrap && couponDataList.availableList.length" class="color_FFB242 f12">{{$t('settlement_promotion_tip')}}</p>
                </div>
            </div>

            <div v-if="isShowCountBox" class="package-buy-quantity">
                <van-cell :title="$t('packages.detail.buy_quantity')">
                    <template>
                        <van-stepper v-model="quantity" theme="round" disable-input min="1" :max="maxQuantity" />
                    </template>
                </van-cell>
            </div>

            <!-- 优惠券模块 -->
            <div class="package-coupon" v-show="!CheckautopayRegulation.payAgreeSymbol_wrap && Module_Coupon">
                <div class="summary_item inner_total_padding border_none border_bottom" v-if="Module_Coupon">
                    <div class="summary_list summary_list_coupon package-coupon-list">
                        <span class="package_coupon_title">{{$t('settlement_Coupon')}}</span>
                        <span class="coupon_select coupon_num fr package-coupon-num" @click.stop="e_openCouponDialog" v-if="!couponSelect">
                            <label class="coupon_canuse mr10" :class="{'coupon_canuse':couponDataList.availableList.length,'coupon_cantuse':couponDataList.availableList.length==0}" v-html="couponDataList.couponText"></label>
                            
                            <van-icon :name="$i18n.locale ==='ar-AE' ? 'arrow-left' : 'arrow'" size=".3rem" color="#999" class="position_top_icon" />
                        </span>
                        <span class="coupon_select fr" v-else><span class="coupon_fee"></span></span>
                        <!-- 有活动 -->
                        <!-- 有使用活动 -->
                        <!-- 选择了优惠券 -->
                    </div>
                    <p v-if="Promotion_detail.PromotionValue && !Promotion_use && couponDataList.selectedCoupon.promotionCode" class="color_FFB242 f12">{{$t('settlement_coupon_tip')}}</p>
                </div>
            </div>

            <div class="package-use-area">
                <div class="box-title">
                    <span>{{ $t('packages.detail.use_area') }}</span>
                    <van-icon :name="iconName" class="toggle-btn" @click="showMoreFun" />
                </div>
                <div class="package-use-area-detail" :class="{'van-multi-ellipsis--l3': !showMore}" v-html="detail.mccListText||showAreaList||mccListText"></div>
            </div>
            <div class="package-use-intro" v-show="detail.showUserDetail">
                <div class="box-title">{{ $t('packages.detail.use_intro') }}</div>
                <div class="package-desc" v-html="detail.showUserDetail" ></div>
            </div>
        </div>

        <div class="bottom-fixed-box van-hairline--top">
            <span class="total-amount">{{ totalAmount }}</span>
            <div class="btn" @click="handlerPayBtn">{{ $t('packages.detail.pay') }}</div>
        </div>

        <van-popup v-model="showPromotionPopup" 
        round closeable position="bottom"
        :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
        :close-on-click-overlay="false"
        class="icon_popup"
        
        :style="{ 'max-height': '80%','min-height': '38%' }">
            <div class="package-show-promotion bottomPopup" v-if="detail.show_Promotion">
                <div class="box-title">{{ $t('packages_detail_promotion') }}</div>
                <div class="package-desc" v-for="(item, index) in detail.PromotionValue" :key="index">
                    <van-cell :icon="item.show_Promotion_icon + ' iconSize' " :title="item.show_Promotion_name" :label="item.show_Promotion_description" ></van-cell>
                </div>
            </div>
        </van-popup>
        <!-- 优惠券弹窗 -->
        <van-popup v-model="status.showCouponPopup" 
        round closeable position="bottom"
        :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
        :close-on-click-overlay="false"
        class="icon_popup"
        @close="e_hideCouponDialog"
        >
            <com-coupon v-if="status.comCoupon" @closeCoupon="e_hideCouponDialog" :dataList="couponDataList" @chooseCoupon="e_selectCoupon"></com-coupon>
        </van-popup>
    </div>
</template>

<script>    
    //import {  keepTwodecimalFull, keepTwodecimalFixed } from '../../utils/util'
    import { Popup } from 'vant';
    import { keepTwodecimalFixed } from '../../utils/util'
    import { pay as payFun } from '../pay/pay'
    import cookie from '../../utils/cookie'
    import baseUtils from "@/utils/baseUtils"
    import autopayRegulation from '@/logic/autopayRegulation';
    import checkProjectConfig from '@/lib/checkProjectConfig';
    import comCoupon from '@/components/com-coupon.vue';
    import AmountHelper from '@/utils/amountHelper';
    import dateUtil from "../../utils/DateUtil";
    const autopayRegulation_url = {
        'zh-CN': 'autopayRegulation_url_zh_cn',
        'zh-TW': 'autopayRegulation_url_zh_tw',
        'en-US': 'autopayRegulation_url_en',
        'tr-TR': 'autopayRegulation_url_tr',
        'ja-JP': 'autopayRegulation_url_ja',
        'vi-VN': 'autopayRegulation_url_vi',
        'th-TH': 'autopayRegulation_url_th',
        'de-DE': 'autopayRegulation_url_de',
        'pt-PT': 'autopayRegulation_url_pt',
        'es-ES': 'autopayRegulation_url_es',
        'fr-FR': 'autopayRegulation_url_fr',
        'it-IT': 'autopayRegulation_url_it',
        'in-ID': 'autopayRegulation_url_in',
        'ru-RU': 'autopayRegulation_url_ru',
        'ar-AE': 'autopayRegulation_url_ar',
        'ko-KR': 'autopayRegulation_url_ko',
        'pl-PL': 'autopayRegulation_url_pl',
        'ms-MY': 'autopayRegulation_url_ms',
        'uz-UZ': 'autopayRegulation_url_uz',
        'nl-NL': 'autopayRegulation_url_nl',
        'sv-SE': 'autopayRegulation_url_sv',
        'fi-FI': 'autopayRegulation_url_fi',
        'da-DK': 'autopayRegulation_url_da',
        'nb-NO': 'autopayRegulation_url_nb',
        'el-GR': 'autopayRegulation_url_el',
        'hu-HU': 'autopayRegulation_url_hu',
        'bg-BG': 'autopayRegulation_url_bg',
        'ro-RO': 'autopayRegulation_url_ro',
        'cs-CZ': 'autopayRegulation_url_cs',
        'sk-SK': 'autopayRegulation_url_sk',
        'sl-SI': 'autopayRegulation_url_sl',
        'sq-AL': 'autopayRegulation_url_sq',
        'hr-HR': 'autopayRegulation_url_hr',
        'lt-LT': 'autopayRegulation_url_lt',
        'lv-LV': 'autopayRegulation_url_lv',
        'et-EE': 'autopayRegulation_url_et',
        'is-IS': 'autopayRegulation_url_is',
        'km-KH': 'autopayRegulation_url_km',
        'lo-LA': 'autopayRegulation_url_lo',
    };
    const SymbolMap = {
        'zh-CN': ', ',
        'zh-TW': ', ',
        'en-US': ', ',
        'ja-JP': ', ',
    };

    export default {
        name: 'PackageDetail',        
        data() {
            return {            
                urlParams: {},
                detail: {},
                showMore: true, // 是否显示全部的“适用区域”
                headerBgImgStyle: { // 根据详情里的 goodsType来判断使用的背景图片
                    //backgroundImage: `url(${require('../../assets/imgs/packages/package_bttc.jpg')})`
                },
                quantity: 1, // 购买数量
                maxQuantity: 1, // 最大购买梳理
                isShowCountBox: false, // 是否显示购买数量栏目
                totalAmount: 0,
                mccListText: '',
                showAreaList:'',
                continuePkgData:{},
                normalPkgData:{},
                normalPkgDataList:[],
                continue_html:'',
                showPromotionPopup:false,
                //------------支付订单页(settlement.vue)移植处理逻辑------------------//
                couponDataList:{//优惠券列表数据
                    availableList:[],//可用优惠券列表
                    unavailableList:[],//不可用优惠券列表
                    selectedCoupon:{},//选中的优惠券数据
                    couponText:"",//优惠栏目展示
                    onlyUseBalance:false,//只能使用余额（使用优惠券后金额为0时）
                    publicValid:true,//公共优惠券是否可用
                    publicTips:"",//公共优惠券是否可用提示
                },
                status:{
                    value:true,
                    showCouponPopup:false,
                    comCoupon:true,//优惠券弹框
                },
                CheckautopayRegulation:{
                    payAgreeSymbol_wrap: false,
                    GeneralPackageHasLxcx_show:false,
                    url:this.$APP_CONFIG[autopayRegulation_url[cookie.getCookie('langType')]],
                },
                couponSelect: false,//选择了促销码（优惠券）
                Promotion_detail:{},
                Promotion_use:"",
                Promotion_use_discount:"",
                usePackageList: [],
                relationId: '',
            }
        },
        components:{
            comCoupon,
        },
        computed: {
            iconName() {
                return this.showMore ? 'arrow-up': 'arrow-down'
            },
            Module_Coupon:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_Coupon",false);
            },
            Module_BuyPackageTips:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_BuyPackageTips",false);
            },
            isRegAndLogin() {
                let isRegAndLogin = JSON.parse(localStorage.getItem('isRegAndLogin') || 'false');
                return isRegAndLogin;
            }
        },
        watch: {
            quantity() {
                this.calTotalAmount();
                if(this.couponDataList.selectedCoupon.promotionCode){
                    this.couponDataList.selectedCoupon = {};
                    this.PayDataPre(true);
                } else {
                    this.PayDataPre();
                }
            }
        },
        mounted() {            
            this.urlParams = this.$route.query;
            this.genHeaderBgImgStyle();                     
            this.getDetail();
            this.getPackageUseDetail();
            //this.getCountryInfo();
            if(this.isShowOrderTips){
                this.handlerShowOrderTips();
            }
        },     
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if(from.name === null && sessionStorage.getItem('currentGoodsCode') === vm.$route.query.goodsCode){
                    vm.isShowOrderTips = true;
                }
            });
        },                
        methods: {
            swithPkg(type,data){
                let isLxcx ;
                let selectPackage ;
                let that =this;
                if(type==0){
                     isLxcx  = true ;
                     this.continuePkgData.select = true ;
                    //  this.normalPkgData.select = false ;
                     this.normalPkgDataList.forEach(item => {
                         item.select = false;
                     })
                     this.isShowCountBox = false;
                     this.quantity = 1;
                }else{
                     isLxcx  = false ;
                     this.continuePkgData.select = false ;
                    //  this.normalPkgData.select = true ; 
                     this.normalPkgDataList.forEach(item => {
                         item.select = false;
                     })
                    this.isShowCountBox = false;
                    data.select = true;
                     this.quantity = 1;
                     if(data.attrMap.maxCount && data.attrMap.maxCount > 1) {                        
                        this.isShowCountBox = true;
                        this.maxQuantity = data.attrMap.maxCount;                        
                    }
                }

                this.detail = data;
                selectPackage = this.detail.goodsId;
                this.calTotalAmount();
                
                try{
                    let data_package = {
                        selectPackage:selectPackage,
                        isLxcx:isLxcx,
                        data:{}
                    }
                     data_package.data[that.continuePkgData.goodsId] = JSON.stringify(this.continuePkgData);
                     this.normalPkgDataList.forEach(item => {
                         data_package.data[item.goodsId] = JSON.stringify(item);
                     })
                    sessionStorage.setItem('data_info',JSON.stringify(data_package));
                }catch(e){
                    let data_package = '{"selectPackage":"'+selectPackage+'","isLxcx":'+isLxcx+',"data":['+JSON.stringify(this.continuePkgData)+','+JSON.stringify({})+']}';
                    sessionStorage.setItem('data_info',JSON.stringify(data_package));
                }

                // this.PayDataPre(this.couponDataList.selectedCoupon.promotionCode);
                // 重置相关的活动和优惠券
                sessionStorage.removeItem('data_promotion');
                this.Promotion_detail = {};
                this.couponDataList.selectedCoupon = {};
                this.getPromotion(this.detail.goodsCode, this.Module_Coupon);
            },
            // 是否展示已有当前套餐订单提示
            handlerShowOrderTips(code) {
                this.$http
                    .post({
                    url: "/bss/app/order/queryOrderListForApp",
                    data: {
                        perPageCount: 1000,
                        orderStatusList: ['UNPAID'],
                        queryLimitFlag: true,
                        custTerminalFlag: 1,
                        filterTopupCode: 1,
                    }
                    })
                    .then(res => {
                        if(res.data && res.data?.dataList?.length){
                            let orderId = '';
                            let isShow = res.data.dataList.some(item => {
                                let packageObj = item.offerList?.[0] || {};
                                if(packageObj.goodsCode === this.$route.query.goodsCode || code === packageObj.goodsCode) {
                                    orderId = item.orderId;
                                    return true;
                                }
                            })

                            if(isShow) {
                                this.$dialog.confirm({
                                    title:this.$t('flowDetail.tip'),
                                    message: this.$t('packages.detail.haveOrderTips'),
                                    confirmButtonText:this.$t('registerlogin.confirm'),
                                    cancelButtonText:this.$t('registerlogin.cancel')
                                }).then(() => {
                                    sessionStorage.removeItem('currentGoodsCode');
                                    this.$router.push(this.$setRouteQuery({name: 'OrderListDetail',query: {orderId: orderId}},this));
                                }).catch(() => {
                                    sessionStorage.removeItem('currentGoodsCode');
                                });
                            }
                        }
                    }).catch(err => {
                        this.$toast(err);
                        console.log(err);
                    });
            },
            //------------支付订单页(settlement.vue)移植处理逻辑------------------
            // 支付数据准备
            PayDataPre(isUseCoupon){
                    let currentURL;
                    let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                    //关联本地方法；
                    autopayRegulation.globalPriceFormat = this.globalPriceFormat;
                    autopayRegulation.e_preCalcOrder = this.CreateMethodToAutopayRegulation;
                    autopayRegulation.getDataAjax = this.getAjax;
                    autopayRegulation.$showDialog = this.$dialog;
                    autopayRegulation.langType = cookie.getCookie('langType');
                    autopayRegulation.createOrder = this.createOrder;
                    // autopayRegulation.$toast = this.$toast;
                    autopayRegulation.$api = this.$api;
                    autopayRegulation.currentIMEI_imei= sessionStorage_UrlData.imei;
                    
                    currentURL= this.$projectConfig[autopayRegulation_url[cookie.getCookie('langType')]];
                    if(currentURL){
                        CheckautopayRegulation.url = currentURL;
                    }
                    //autopayRegulation.$vux = this.$vux;
                    try{
                        let data_info = JSON.parse(sessionStorage.getItem('data_info'));
                        let data_promotion = JSON.parse(sessionStorage.getItem('data_promotion')||0);
                        if(data_info){
                            let tempData = data_info.data[data_info.selectPackage]
                            this.payInitData(JSON.parse(tempData), data_promotion,data_info['isLxcx'],isUseCoupon);
                        }
                    }catch(e){
                        console.log(e);
                    }
            },
            payInitData(tempData,promotionData,isLxcx,isUseCoupon) {
                let total = AmountHelper.multiply(tempData.goodsPrice, this.quantity);
                this.Subtotal =  this.doPriceStyle(tempData,total);
                tempData.priceStr = this.doPriceStyle(tempData,total);
                tempData.actualPaymentAmount = total;

                // 展示金额修改为销售品金额
                this.ShowPrice = this.doPriceStyle(tempData,tempData.goodsPrice);
                this.packageData = tempData;
                autopayRegulation.categoryCode_IS_LXCX(tempData);//判断是否连续畅享
                autopayRegulation.currentGoodsName = tempData.goodsName;
                this.ShowAutopayRegulation();//展示连续畅享
                //是否需要查询优惠码
                if(this.Module_Coupon && !isLxcx){
                    this.e_queryAssociatedPromotion(total, isUseCoupon ? false : promotionData);  
                }
                if(promotionData && !isLxcx){
                    this.Promotion_detail = promotionData;
                    if(!isUseCoupon){
                        //从套餐获取最佳优惠券编码
                        this.e_preCalcOrder(false , tempData.promotionActivityCode);
                    }
                }
            },
            ShowAutopayRegulation(){
                // this.CheckautopayRegulation.payAgreeSymbol_wrap = autopayRegulation.payAgreeSymbol_wrap;
                if(this.detail.categoryCode=="LXCX" && +this.detail?.attrMap?.payAgreeFlag == 1){
                    this.CheckautopayRegulation.payAgreeSymbol_wrap = true;
                } else {
                    this.CheckautopayRegulation.payAgreeSymbol_wrap = false;
                }
                this.CheckautopayRegulation.sale_Promotion = autopayRegulation.sale_Promotion;
                this.CheckautopayRegulation.GeneralPackageHasLxcx_show = autopayRegulation.GeneralPackageHasLxcx_show;
                this.CheckautopayRegulation.Contract_recommendation = autopayRegulation.Contract_recommendation;
                this.CheckautopayRegulation.goToLxcxPkg = autopayRegulation.goToLxcxPkg;
            },
            // 查询优惠码
            e_queryAssociatedPromotion(total,promotionData){
                let that = this;
                let params = {
                    "perPageCount":1000,
                    "currentPage":1,
                };
                let selectedCoupon = this.urlParams.promotionCode ? {
                    promotionCode: this.urlParams.promotionCode
                } : JSON.parse(sessionStorage.getItem('data-selectedCoupon') || "{}");
                
                that.$set(that.couponDataList,"availableList",[]);
                that.$set(that.couponDataList,"unavailableList",[]);
                that.$http.post(that.$api.queryPromotionInst, params).then(d => {
                    let data = [];
                    let selectedCouponOp = {};
                    if(d && d.data && d.data.dataList){
                        data =  d.data.dataList
                    }
                     
                    // quota----如果是金额，单位：元，如果是百分比，则在0-100%
                    for(let i in data){
                        data[i].validPeriod = dateUtil.formatDateTime(new Date(data[i].effectiveDate), 'yyyy/MM/dd HH:mm')+" - "+dateUtil.formatDateTime(new Date(data[i].expiryDate), 'yyyy/MM/dd HH:mm');
                        
                        if(data[i].promotionMode=="P01"||data[i].promotionMode=="P03"){//P01：满减百分比;蓝色  P03:直减百分比;绿色
                            data[i].offerLogo = "OFF";
                            data[i].preferentialRatio = data[i].quota+"%";
                        }else if(data[i].promotionMode=="P02"||data[i].promotionMode=="P04"){//-P02:满减金额;橘色  //P04:直减金额;橙色
                            data[i].offerLogo = that.packageData.currencyType;
                            data[i].preferentialRatio = data[i].quota;
                        }
                    }
                    let cutPrice = 0;
                    // 可用与不可用优惠券
                    for(let val in data){
                        if(data[val].status=="AVAILABLE"){
                            if( (data[val].goodsList.indexOf(that.packageData.goodsId)>-1||data[val].goodsList.indexOf("ALL")>-1) && (((data[val].promotionMode=="P01"||data[val].promotionMode=="P02") && parseInt(total) >= data[val].fullCut*100)||data[val].promotionMode=="P03"||data[val].promotionMode=="P04") ){//可用的优惠码
                                that.couponDataList.availableList.push(data[val]);
                                // 默认选中点击的优惠券
                                if(selectedCoupon.promotionCode === data[val].promotionCode && !promotionData){
                                    that.couponDataList.selectedCoupon = data[val];
                                }
                                
                                // P01：满减百分比;P02:满减金额;P03:直减百分比;P04:直减金额
                                // 如果没有点击优惠券，则默认选择最优优惠券
                                let currCutPrice = 0;
                                if(['P01','P03'].includes(data[val].promotionMode)){
                                    currCutPrice = (+that.packageData.goodsPrice) * (data[val].quota / 100);
                                } else {
                                    currCutPrice = data[val].quota * 100;
                                }

                                if(currCutPrice > cutPrice) {
                                    selectedCouponOp = data[val];
                                    cutPrice = currCutPrice;
                                }

                            }else{
                                that.couponDataList.unavailableList.push(data[val]);
                            }
                        }
                    }
                    that.couponDataList.couponText = that.couponDataList.availableList.length>0?(that.couponDataList.availableList.length+` ${that.$t('settlement_Not_used_coupon')}`):that.$t('settlement_No_coupon')
                    // 有默认选中优惠券则进行预计算
                    if(that.couponDataList.selectedCoupon?.promotionCode){
                        that.e_preCalcOrder();
                    } else if(!that.couponDataList.selectedCoupon?.promotionCode && selectedCouponOp?.promotionCode &&　!promotionData) {
                        that.couponDataList.selectedCoupon = selectedCouponOp;
                        that.e_preCalcOrder();
                    } else {
                        that.e_preCalcOrder();
                    }
                },err=>{
                    that.$toast(err.resultDesc);
                })
            },
            CreateMethodToAutopayRegulation(payAgreeFlag){
                let that = this;
                this.e_preCalcOrder( payAgreeFlag );
            },
            getAjax(ajaxUrl,ajaxData){
                return this.$http.post(ajaxUrl, ajaxData);
            },
            //预计算价格，如果优惠后total=0则只能使用余额支付
            e_preCalcOrder( payAgreeFlag , Current_Chose_Promotion_actCode ){
                let that = this,da=that.packageData,pkgList = [];
                if( da.attrMap && (da.attrMap.expType=="USER_DEFINED"||da.attrMap.expType=="MAKE_APPOINTMENT"||da.attrMap.expType=="USER_DEFINED"||da.attrMap.expType=="MAKE_APPOINTMENT") ){
                    pkgList.push({"goodsId":da.goodsId,"quanity":that.quantity,"effectiveTime":da.effectiveTime,"expireTime":da.expireTime})
                }else{
                    pkgList.push({"goodsId":da.goodsId,"quanity":that.quantity})
                }
                let params = {
                    actCode:Current_Chose_Promotion_actCode,
                    userCode: JSON.parse(localStorage.getItem("userInfo"))['userCode'],
                    payCurrencyType: that.packageData.currencyType,
                    goodsList: pkgList,
                    promotionCode:that.couponDataList.selectedCoupon.promotionCode||"",
                    "payMethod": "ACCOUNT_AMOUNT",//that.currentPay.toUpperCase(),
                };
                if(payAgreeFlag){
                    params.payAgreeFlag = 1;
                }
                that.couponDataList.onlyUseBalance = false;
                that.$http.post(that.$api.preCalcOrder, params).then(d => {
                    if(d && d.data){
                        if(d.data.payPrice==0){
                            // that.selectPayment ("ACCOUNT_AMOUNT");
                            console.log('价格不能为0,没有余额支付');
                            that.couponDataList.onlyUseBalance = true;
                        }
                        let _payPrice= that.doPriceStyle(that.packageData,d.data.payPrice)
                        that.$set(that.packageData,"priceStr",_payPrice);
                        this.totalAmount = _payPrice;
                        that.$set(that.packageData,"actualPaymentAmount",d.data.payPrice);//记录优惠后的价格
                        // that.getPaymentList();
                        that.canUseBalance = false;
                        if(JSON.stringify(that.couponDataList.selectedCoupon)=="{}"){
                            that.couponDataList.couponText = that.couponDataList.availableList.length>0?(that.couponDataList.availableList.length+` ${that.$t('settlement_Not_used_coupon')}`):that.$t('settlement_No_coupon');
                        }else{
                            that.couponDataList.couponText = `<span ${that.isCurrencySymbol(that.packageData.currencyType) ? '' : "dir='ltr'"}>` +　"-"+that.doPriceStyle(that.packageData,d.data.promotionDiscount) + "</span>";
                            // 记录优惠价格
                            that.$set(that.packageData,'promotionDiscount',d.data.promotionDiscount);
                        }
                        //如果有营销活动
                        //支付前确认使用优惠券还是营销活动
                        if(d.data && d.data.goodsList  && d.data.goodsList[0].mktInfo){
                            let _mktInfo = d.data.goodsList[0].mktInfo;
                            that.Promotion_use = _mktInfo.actCode;
                            if(_mktInfo.discount){
                                that.Promotion_use_discount = "- " + that.doPriceStyle(that.packageData,_mktInfo.discount);
                            }
                        }else{
                            that.Promotion_use = '';
                            that.Promotion_use_discount = '';
                        }
                    }
                    
                },err=>{
                    that.$toast(err.resultDesc);
                    // that.$vux.toast.show({
                    //     text: err.resultDesc,
                    //     position: 'bottom',
                    //     type: 'text',
                    //     time: '2000'
                    // });
                })
            },
            // 生成订单
            async createOrder(payMethod='ACCOUNT_AMOUNT', payAgreeFlag) {
                let orderObj = {},that = this,
                    channelType = that.$APP_CONFIG.request.channelType;
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let params = {
                    channelType,
                    orderType: 'BUYPKG',
                    currencyType: this.packageData.currencyType,
                    goodsList: [{
                        goodsId: this.packageData.goodsId,
                        quanity: this.quantity,
                        effectiveTime: 0,
                        expireTime: 0
                    }],
                    buyImei:autopayRegulation.currentIMEI_imei,
                    orderMark: '',
                    payMethod,
                    payAgreeFlag: payAgreeFlag&&1 || 0
                };

                //连续包月订购功能
                if(payAgreeFlag){
                    params.payAgreeFlag = 1;
                }

                 // 使用优惠券
                if(JSON.stringify(that.couponDataList.selectedCoupon)!="{}"){
                    params.promotionCode = that.couponDataList.selectedCoupon.promotionCode;
                    params.promotionInstId = that.couponDataList.selectedCoupon.id;
                }

                //有营销活动 并使用
                if(that.Promotion_use){
                    params.actCode = that.Promotion_use;
                }

                // 为家庭组下的生成订单
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    params.imei = JSON.parse(sessionStorage.getItem('urlData') || '{}')?.imei;
                    delete params.buyImei;
                }

                // sn登录，未用imei登录，创建订单使用sn
                if(urlData.sn){
                    params.userCode = urlData.userCode;
                    delete params.buyImei;
                }
                await this.$http.post({
                    url: '/bss/app/order/CreateOrder',
                    data: {
                        ...params
                    }
                }).then(res => {
                    if(res.data && res.data.orderSN) {
                        orderObj = res.data;
                        // 如果创建订单一些数据没有拿到则返回
                        if(!orderObj.orderSN) {
                            this.$toast(this.$t('packages.confirm.create_order_error'));
                        }else{
                            that.getOrderInfo(orderObj,payAgreeFlag&&'CYCLE'||'PAY');    
                        }
                        
                    }
                }).catch(err => {                    
                    this.$toast(err);
                });

                return orderObj;
            },
            // 点击支付按钮，校验是否有已购买套餐
            handlerPayBtn() {
                if(!this.usePackageList || !this.usePackageList.length || !this.Module_BuyPackageTips){
                    this.onlinePayment();
                    return;
                }

                let isLXCX = this.detail.categoryCode === 'LXCX' && this.detail.payAgreeFlag == '1';

                if(isLXCX) { // 当前是连续包月套餐
                    if(this.usePackageList.some(item => {
                        return item.goodsCode === this.detail.goodsCode
                      })
                    ){
                        // 已经购买当前连续畅享套餐
                        this.onlinePayment();
                    } else if (
                        this.usePackageList.some(item => item.categoryCode !== 'LXCX' && !item.isLessThree)
                    ) { // 已购买非连续畅享且剩余天数大于3天的套餐展示弹窗
                        let packageDetail = this.usePackageList.find(item => item.categoryCode !== 'LXCX' && !item.isLessThree);
                        this.dialogConfirm(packageDetail.goodsName);
                    } else {
                        this.onlinePayment();
                    }
                } else {
                    if(this.relationId){
                        // 调用接口查询自动续订是否续存
                        //查询连续包月的协议
                        let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                        this.$http.post(this.$api.queryAgreement,{imei: urlData.imei}
                        ).then(
                            (res)=>{
                            var agreementMapKeys = Object.keys(res.data.agreementMap);
                            var agreementsLength = agreementMapKeys.length;
                            let unsubscribeFlag = false;
                            if (agreementsLength > 0) {
                                for (var i = 0; i < agreementsLength; i++) {
                                    if (res.data.agreementMap[agreementMapKeys[i]].indexOf(this.relationId) != -1) {
                                        unsubscribeFlag = true;
                                        break;
                                    }
                                }
                            }

                            if(unsubscribeFlag){ // 续订关系存在，直接提示
                                let packageDetail = this.usePackageList.find(item => item.relationId === this.relationId);
                                this.dialogConfirm(packageDetail.goodsName);
                            } else {
                                this.onlinePayment();
                            }

                        }).catch(error => {
                            this.$toast(error);
                            console.log(error);
                        })

                    } else if (this.usePackageList.some(item => item.categoryCode !== 'LXCX' && !item.isLessThirty)) { // 已购买非连续畅享且剩余天数大于30天的套餐展示弹窗
                        let packageDetail = this.usePackageList.find(item => item.categoryCode !== 'LXCX' && !item.isLessThirty);
                        this.dialogConfirm(packageDetail.goodsName);
                    } else {
                        this.onlinePayment();
                    }
                }
            },
            dialogConfirm(goodsName) {
                let message = this.$t('packages.detail.buy_tips').replace('%@packageName',goodsName);
                this.$dialog.confirm({
                    title:this.$t('flowDetail.tip'),
                    message: message,
                    confirmButtonText:this.$t('registerlogin.confirm'),
                    cancelButtonText:this.$t('registerlogin.cancel')
                }).then(() => {
                    this.onlinePayment();
                }).catch(() => {
                })
            },
            async onlinePayment() {
                // 先要生成订单
                //只有在线支付 -- PAYONLINE，没有余额支付 --- ACCOUNT_AMOUNT
                let orderData,payFunction,checkPay,type="PAYONLINE";

                //是否是周期扣款
                if(!autopayRegulation.CurrentPackageStatusISLXCX){

                    payFunction = 'PAY'
                    orderData = this.createOrder(type);

                }else{
                    //周期扣款
                    payFunction = 'CYCLE';
                    orderData = autopayRegulation._RechargePaymentAccess(type);
                }

                let params = {
                    order_amount:AmountHelper.multiply(this.packageData.goodsPrice, this.quantity) / 100,
                    order_actual_amount:this.packageData.actualPaymentAmount / 100,
                    data_package_code:this.packageData.goodsCode,
                    data_package_name:this.packageData.goodsName,
                    monetary_unit:this.packageData.currencyType,
                    effective_days_num:this.packageData.periodUnit === 'DAY' ? +this.packageData.period : +this.packageData.period * 30,
                    data_num:this.packageData.flowByte,
                }

                if(this.couponDataList?.selectedCoupon?.promotionCode){
                    params = {
                        ...params,
                        coupon_id:this.couponDataList.selectedCoupon.promotionId,
                        coupon_name:this.couponDataList.selectedCoupon.promotionName['zh-CN'] || this.couponDataList.selectedCoupon.promotionName,
                        coupon_amount:this.packageData.promotionDiscount / 100,
                        coupon_code:this.couponDataList.selectedCoupon.promotionCode,
                    }
                }
                
                // 神策-点击在线支付
                this.$sensors.track('WebDataPackagePayClick', {
                    ...params,
                });
            },
            getOrderInfo(orderData,payFunction){
                //国家维度自定义收银台支付模板
                let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let countryCode = sessionStorage_UrlData.registerCountry|| 
                                    this.$projectConfig.registerCountry||
                                    sessionStorage_UrlData.placeCode||'';
                // 去收银台支付
                payFun({
                    orderSn: orderData.orderSN,
                    totalAmount: orderData.amount,
                    currencyCode: this.packageData.currencyType,
                    orderDesc: this.packageData.goodsName,
                    orderSubject: this.packageData.goodsName,
                    payFunction:payFunction,
                    countryCode:countryCode,
                    goodsCode:this.detail.goodsCode,
                });
            },
            //打开优惠券弹框
            e_openCouponDialog(){
                let that = this;
                that.status.showCouponPopup = true;
                that.status.comCoupon = true;
                that.couponDataList.publicValid = true;
                that.couponDataList.publicTips = "";
                // that.stopMove();
            },
            //关闭优惠券弹框
            e_hideCouponDialog(){
                this.status.showCouponPopup = false;
                setTimeout(() => {
                    this.status.comCoupon = false;
                }, 500);
            },
            //已选中优惠券
            e_selectCoupon(d,type){
                let that = this;
                if(type=="private"){
                    that.couponDataList.selectedCoupon = d;
                    that.e_preCalcOrder();
                }else{
                    if(JSON.stringify(d)=="{}") {
                        that.couponDataList.selectedCoupon = {};
                        that.e_preCalcOrder();
                        return;
                    }
                    that.e_queryPublicPromotionInfo(d);
                }
            },
            //查询公共促销码是否可用
            e_queryPublicPromotionInfo(code){
                let that = this;
                var params = {
                    "promotionCode":code||"",
                    "goodsList":[that.packageData.goodsId],
                };
                that.$http.post(that.$api.queryPromotionInfo, params).then(d => {
                    that.couponDataList.selectedCoupon = {
                        "promotionCode":d.data.promotionCode,
                        "promotionName":d.data.promotionName,
                        "promotionId":d.data.id,
                    }
                    that.e_preCalcOrder();
                    setTimeout(() => {
                        that.e_hideCouponDialog();
                    }, 300);
                },err=>{
                    that.couponDataList.publicValid = false;
                    that.couponDataList.publicTips = err.resultDesc;
                })
            },
            // 选择使用优惠活动
            selectPromotion() {
                if(this.Promotion_use_discount && !this.couponDataList?.availableList?.length) return;
                this.couponDataList.selectedCoupon = {};
                this.PayDataPre();
            },
            //------------支付订单页移植处理逻辑------------------
            // 是否显示购买天数栏目
            isShowCountBoxHandler(item) {                
                try {
                    if(item.attrMap.maxCount && item.attrMap.maxCount > 1 && (!['LXCX'].includes(item.categoryCode) && item.payAgreeFlag != '1')) {                        
                        this.isShowCountBox = true;
                        this.maxQuantity = item.attrMap.maxCount;                        
                    }
                } catch(err) {
                    this.isShowCountBox = false
                }
            },            
            // 收起和展开使用区域内容
            showMoreFun() {
                this.showMore = !this.showMore
            },
            goBack() {
                this.$router.go(-1);
            },
            // // 生成订单
            // async createOrder(payMethod='ACCOUNT_AMOUNT') {
            //     let orderObj = {},
            //         channelType = this.$APP_CONFIG.request.channelType;
            //     let params = {                    
            //         channelType,
            //         orderType: 'BUYPKG',
            //         currencyType: this.detail.currencyType,
            //         goodsList: [{
            //             goodsId: this.detail.goodsId,
            //             quanity: this.quantity,
            //             effectiveTime: 0,
            //             expireTime: 0
            //         }],
            //         orderMark: '',
            //         payMethod,
            //         payAgreeFlag: 0
            //     };

            //     // 为家庭组下的生成订单
            //     if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
            //         params.imei = JSON.parse(sessionStorage.getItem('urlData') || '{}')?.imei
            //     }

            //     await this.$http.post({
            //         url: '/bss/app/order/CreateOrder',
            //         data: {
            //             ...params
            //         }
            //     }).then(res => {
            //         if(res.data && res.data.orderSN) {
            //             orderObj = res.data;
            //         }
            //     }).catch(err => {                    
            //         this.$toast(err);
            //     });

            //     return orderObj;
            // },
            //要输入优惠券重新进入新页面
            goSettlement_page(){
                this.$router.push({
                    name: 'settlement',
                    query: {
                        ...this.$route.query,
                        quantity: this.quantity
                    }                 
                });
                
                // 神策-点击购买套餐按钮
                this.$sensors.track('WebDataPackageBuyClick', {
                    data_package_code:this.detail.goodsCode,
                    data_package_name:this.detail.goodsName,
                    data_package_type: (this.detail.iso2List.length > 1 || this.detail.iso2List[0] == 'ALL') ? '跨区域流量包' : '地区流量包',
                    data_package_quantity: this.quantity,
                    data_package_amount:+this.detail.goodsPrice / 100,
                    monetary_unit:this.detail.currencyType,
                    effective_days_num:this.detail.periodUnit === 'DAY' ? +this.detail.period : +this.detail.period * 30,
                });
            },
            // // 点击订购按钮
            // async goPayment() {
            //     /*
            //     this.$router.push({
            //         name: 'PackageBuyConfirm',
            //         query: {
            //             goodsCode: this.detail.goodsCode,
            //             quantity: this.quantity
            //         }                 
            //     });
            //     */
            //    // 先要生成订单
            //     let orderData = await this.createOrder();
            //     // 如果创建订单一些数据没有拿到则返回
            //     if(!orderData.orderSN) {
            //         this.$toast(this.$t('packages.confirm.create_order_error'));
            //         return;
            //     }

            //     // 去收银台支付
            //     payFun({
            //         orderSn: orderData.orderSN,
            //         totalAmount: orderData.amount,
            //         currencyCode: this.detail.currencyType,
            //         orderDesc: this.detail.goodsName,
            //         orderSubject: this.detail.goodsName
            //     });
            // },
            calTotalAmount() {
                let price = this.detail.goodsPrice * this.quantity;
                if(this.detail.discountPrice){
                    price = this.detail.discountPrice * this.quantity;
                }
                this.totalAmount = this.doPriceStyle(this.detail, price)
            },
            // 赋值顶部背景图片
            genHeaderBgImgStyle() {                        
                if(this.urlParams.goodsType == 'PKAG') {
                    this.$set(this.headerBgImgStyle, 'backgroundImage', `url(${require('../../assets/imgs/packages/flowpackage.jpg')})`);
                } else {
                    this.$set(this.headerBgImgStyle, 'backgroundImage', `url(${require('../../assets/imgs/packages/package_bttc.jpg')})`);                    
                }
            },
            /*
            getCountryInfo() {
                this.$http.post({
                    url: '/interfaces/getCountryInfo?giso=CN',
                    auth: false,
                    data: {
                        keyword: '',
                        search: 1                        
                    }
                }).then(res => {
                    console.log(res)
                });
            },
            */
            // 获取流量套餐详情
            getDetail() {
                this.getPackageDetail(this.urlParams.goodsCode)
                    .then(res => {
                        if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                            this.initData(res.data.dataList);

                            let goods = res.data.dataList[0];
                            let day_num = goods.periodUnit === 'DAY' ? +goods.period : +goods.period * 30;
                            // 神策-浏览套餐详情
                            this.$sensors.track('WebDataPackageDetail', {
                                data_package_detail_souce: this.$route.query.souce,
                                data_package_code: goods.goodsCode,
                                data_package_name: goods.goodsName,
                                data_package_type: (goods.iso2List.length > 1 || goods.iso2List[0] == 'ALL') ? '跨区域流量包' : '地区流量包',
                                data_package_amount: +goods.goodsPrice / 100,
                                data_num:goods.flowByte,
                                effective_days_num:day_num,
                                monetary_unit:goods.currencyType,
                            });
                        } else {
                            this.$router.push({
                                name: 'LoadFail',
                                query: {
                                    url: window.location.href
                                }
                            })
                        }
                    }).catch(err => {
                        this.$toast(err)
                        window.setTimeout(() => {
                            this.$router.push({
                                name: 'LoadFail',
                                query: {
                                    url: window.location.href
                                }
                            })
                        }, 2000);
                    });
            },
            async initData(list) {
                let that = this;
                this.detail = list[0];
                this.detail.goodsPrice = +this.detail.goodsPrice + '';                       
                try { 
                    this.isShowCountBoxHandler(this.detail);

                    this.detail.mccList = this.detail.mccList.filter(mcc => {                        
                        if(mcc) return mcc
                    });

                    let high_speed_text = this.genHighSeepText(this.detail);
                    
                    await that.handlePackage(that.detail, high_speed_text );

                    //流量商城原本属性值
                    // this.detail = {
                    //     ...this.detail,
                    //     packageDesc: this.detail.attrMap.pkDesc,
                    //     goodsPriceText: this.doPriceStyle(this.detail, this.detail.goodsPrice),
                    //     mccListText: this.detail.mccList.join(SymbolMap[cookie.getCookie('langType')]),
                    //     flowByteText: this.doFlowByteText(this.detail) + ' ' + high_speed_text,
                    //     periodText: `${this.detail.period} ${this.detail.period > 1 ? 
                    //                     this.$t(`packages.periodUnits.${this.detail.periodUnit.toLowerCase()}`) : 
                    //                     this.$t(`packages.periodUnit.${this.detail.periodUnit.toLowerCase()}`)}`
                    // }

                    this.calTotalAmount();
                    this.getMccListText();
                    that.goodsExtendAttrs(that.detail,that.detail);
                    this.getPromotion(this.detail.goodsCode);
                } catch(err) {
                    console.log('initData 初始化异常',err);
                    this.$toast(err);
                }
            },
            async handlePackage( tempData , high_speed_text ){
                let that = this,flow;
                // 按照套餐分类显示
                // 这里的流量值没有判断DISC
                /*
                PKAG 流量包
                COMM 普通销售品
                DISC 优惠销售品
                BASE 基础销售品
                DDTC 兜底套餐
                */
                // ['BTTC', 'BYTC', 'SWBY', 'CXTC','ZLTC'].includes(tempData.categoryCode)
                // if (tempData.categoryCode === "BTTC" || 
                //     tempData.categoryCode === "BYTC" || 
                //     tempData.categoryCode === "SWBY" || 
                //     tempData.categoryCode === "CXTC" || 
                //     tempData.categoryCode === "ZLTC") {
                //         if(!!(tempData.flowByte) && tempData.flowByte>0){
                //             flow = baseUtils.trafficRules(tempData.flowByte)+" "+this.$t('packages.high_speed_text');
                //         }else{
                //             flow = this.$t('packages.infiniteFlow');
                //         }
                //     } else {
                //         if (tempData.goodsType == 'DISC') { 
                //             flow = baseUtils.trafficRules(tempData.flowByte)+" "+this.$t('packages.high_speed_text');    
                //         }else{
                //             flow = baseUtils.trafficRules(tempData.flowByte);
                //         }
                        
                // } 

                //按照老业务展示流量大小
                tempData.showFlow = this.doFlowByteText(tempData) + ' ' + high_speed_text;
                tempData.showPeriod = this.getValidityPeriod(tempData);
                //元转分 方法统一使用该项目处理方案
                // tempData.showPrice = tempData.currencyType + ' ' + this.commonHelper.FenToYuan(tempData.goodsPrice)
                tempData.showPrice = that.doPriceStyle(tempData, tempData.goodsPrice);
                tempData.showUserDetail = tempData.attrMap.pkDesc;
                tempData.showIsInfinite = tempData.attrMap.infiniFlag;
                this.mccLength = tempData.iso2List.length;
                tempData.periodStr = (tempData.billingInfos && tempData.billingInfos[0]) ?  this.moOrDay(tempData.billingInfos[0]) : '' ;

                //使用该处理，与 getMccListText 方法处理一致
                // if (tempData.iso2List && this.mccLength > 10) {
                //     this.sortByContinent(tempData.iso2List).then(response => {
                //         this.showAreaList = response;
                //     });
                // } else {
                //     this.showAreaList = tempData.mccList;
                // }

                //复用流量商城原始方法获取地区
                this.showAreaList = tempData.mccList.join(SymbolMap[cookie.getCookie('langType')]||', ');

                //连续畅销
                tempData.firstPrice = '';
                tempData.oringPrice = '';
                
                //营销活动划线价格
                if(tempData.discountPrice){

                    tempData.showPrice = that.doPriceStyle(tempData, tempData.discountPrice);
                    //tempData.goodsPrice 此处单位和货币展示不处理，由模板处理
                    tempData.oringPrice = tempData.goodsPrice; 
                }
                if(tempData.categoryCode === "LXCX" && tempData.payAgreeFlag == '1'){
                    this.normalPkgDataList = await this.getAgreePackage();

                    let preCalcOrder ;

                    
                    
                    if(cookie.getCookie("access_token") && localStorage.getItem('loginCustomerId') ){
                        preCalcOrder = await this.preCalcOrder(tempData);
                    }
                    
                    
                    

                    let html = '' ;
                    let selectPackage ;
                    let isLxcx ;
                    //处理连续包月套餐
                    tempData.select = true ;
                    tempData.periodTxt = tempData.periodUnit == 'MONTH' ? this.$t('packages.continuousMonth') : this.$t('packages.continuousDay');
                    html += '<p class="se_title">' + tempData.periodTxt +'</p>';
                    if(tempData.deductionInfo){
                        tempData.firstPrice = tempData.deductionInfo.autoRenewFirstPrice < tempData.deductionInfo.autoRenewPrice ?tempData.deductionInfo.autoRenewFirstPrice : '';
                        tempData.oringPrice =  tempData.goodsPrice ;
                        tempData.goodsPrice = tempData.deductionInfo.autoRenewPrice < parseInt(tempData.goodsPrice) ? tempData.deductionInfo.autoRenewPrice : tempData.goodsPrice ;
                        tempData.goodsPrice = preCalcOrder ? preCalcOrder.data.payPrice : tempData.goodsPrice ;
                        // tempData.showPrice = tempData.currencyType + ' ' + this.commonHelper.FenToYuan(tempData.goodsPrice);

                        tempData.showPrice = that.doPriceStyle(tempData, tempData.goodsPrice);
                        if(tempData.firstPrice){
                            //有预计算就显示预计算价格
                            let realprice = preCalcOrder ? that.doPriceStyle(tempData,preCalcOrder.
                                data.payPrice) : that.doPriceStyle(tempData,tempData.firstPrice) ;

                            html += '<p class="se_content">'+that.$t('orderTips.First_charge_discount') + '</p>';

                            html = html.replace('%@firstMoney',that.doPriceStyle(tempData,tempData.firstPrice)).replace('%@money',that.doPriceStyle(tempData,tempData.deductionInfo.autoRenewPrice)).replace(new RegExp('%@periodSymbol',"g"),tempData.periodStr);
                            
                            html += '<p class="se_package_price">'+realprice+'   <i class="oprice">'+that.doPriceStyle(tempData,tempData.oringPrice) +'</i></p>';
                            tempData.firstShowPrice =  realprice;
                        }else{ //不存在首次优惠则计算和普通包月差价
                            if(tempData.oringPrice > tempData.goodsPrice){
                                tempData.savePrice = parseInt(tempData.oringPrice) - parseInt(tempData.goodsPrice);

                                html += '<p class="se_content">'+that.$t('orderTips.Monthly_discount') + '</p>';

                                html = html.replace('%@saveMoney',that.doPriceStyle(tempData,tempData.savePrice)).replace('%@period',tempData.periodStr);

                                html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'  <i class="oprice">'+that.doPriceStyle(tempData,tempData.oringPrice)+'</i></p>';
                            }else{
                                html += '<p class="se_content">'+ that.$t('detail_se_content') + '</p>';
                                html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'</p>';
                            }
                        }   
                    }else{

                        html += '<p class="se_content">' + that.$t('detail_se_content') +'</p>';
                        html += '<p class="se_package_price">'+that.doPriceStyle(tempData,tempData.goodsPrice)+'</p>';
                    }
                    
                    this.continue_html = html;
                    this.continuePkgData = tempData;
                    isLxcx  = true ; //默认选择
                    selectPackage = tempData.goodsId;
                    
                    try{
                        let data_package = {
                            selectPackage:selectPackage,
                            isLxcx:isLxcx,
                            data:{}
                        }
                        if(that.continuePkgData.goodsId){
                            data_package.data[that.continuePkgData.goodsId] = JSON.stringify(this.continuePkgData);   
                        }
                         
                         if(that.normalPkgDataList && that.normalPkgDataList.length){
                            that.normalPkgDataList.forEach( item => {
                                data_package.data[item.goodsId] = JSON.stringify(item);   
                            });
                         }
                         
                        
                        sessionStorage.setItem('data_info',JSON.stringify(data_package));
                    }catch(e){
                        let data_package = '{"selectPackage":"'+selectPackage+'","isLxcx":'+isLxcx+',"data":['+JSON.stringify(this.continuePkgData)+','+JSON.stringify(this.normalPkgDataList[0] || {})+']}';
                        sessionStorage.setItem('data_info',data_package);
                        console.log('数据异常,请仔细检查')
                    }

                }else{
                    let isLxcx  = false ; //默认选择
                    let selectPackage = tempData.goodsId;
                    
                    try{
                        let data_package = {
                            selectPackage:selectPackage,
                            isLxcx:isLxcx,
                            data:{}
                        }
                        if(tempData.goodsId){
                            data_package.data[selectPackage] = JSON.stringify(tempData);   
                        }
                         
                        sessionStorage.setItem('data_info',JSON.stringify(data_package));
                    }catch(e){
                        let data_package = '{"selectPackage":"'+
                                            selectPackage+
                                            '","isLxcx":'+
                                            isLxcx+
                                            ',"data":['+
                                            JSON.stringify({})+
                                            ']}';
                        sessionStorage.setItem('data_info',data_package);
                        console.log('数据异常,请仔细检查')
                    }
                }
                
                sessionStorage.setItem('data_coverage',tempData.iso2List);
                //this.packageData 已存在，在此项目使用 that.detail
                //利用对象的引用值更改赋值
                //this.packageData = tempData;

            },
            getPromotion(goodsCode, isUseCoupon){
                let that = this;
                let actDetailList = { //营销活动
                    goodsCode,
                    params:{
                        "queryVipDayFlag":false,
                        "supportExclusive":true
                    }
                }
                that.$http.post(this.$api.getPromotion, actDetailList)
                .then(res => {
                        if(res.data && res.data.length > 0) {
                            let data = res.data.filter(item => {
                                return item.code == that.detail.promotionActivityCode
                            });
                            that.$nextTick(() => {
                                that.$set(that.detail, 'show_Promotion', true);
                            });
                            
                            that.detail.PromotionValue = [];
                            for (let a in data) {
                                
                                that.detail.PromotionValue[a] ={};
                                if(data[a].actionType[0] =='P05') {

                                    that.detail.PromotionValue[a].show_Promotion_icon = 'sale';
                                }else if(data[a].actionType[0] == 'P01' || data[a].actionType[0] == 'P03') {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'discount';
                                }else if(data[a].actionType[0] == 'P02' || data[a].actionType[0] == 'P04') {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'deduction';
                                }else {
                                    that.detail.PromotionValue[a].show_Promotion_icon = 'gift';
                                }
                                
                                
                                let actLanguageList = data[a].actLanguageList;
                                // 使用 find 方法找到 languageType 为 "en-US" 的对象
                                const enUsLanguageItem = actLanguageList.find(item => item.languageType == "en-US");
                                console.log(cookie.getCookie('langType'));
                                const langType_UsLanguageItem = actLanguageList.find(item => item.languageType == cookie.getCookie('langType'));
                                 
                                // 检查是否找到了对象，并获取其 name 值
                                if (langType_UsLanguageItem) {
                                    that.detail.PromotionValue[a].show_Promotion_name = langType_UsLanguageItem.name;
                                    that.detail.PromotionValue[a].show_Promotion_description = langType_UsLanguageItem.description && langType_UsLanguageItem.description || '';
                                } else {
                                    that.detail.PromotionValue[a].show_Promotion_name = enUsLanguageItem.name;
                                    that.detail.PromotionValue[a].show_Promotion_description = enUsLanguageItem.description && enUsLanguageItem.description || '';
                                }

                            }
                            sessionStorage.setItem('data_promotion',JSON.stringify(that.detail));

                            // 支付数据初始化
                            this.PayDataPre(this.$route.query.promotionCode || isUseCoupon);
                        } else {
                            sessionStorage.removeItem('data_promotion');
                            
                            // 支付数据初始化
                            this.PayDataPre(this.$route.query.promotionCode || isUseCoupon);
                        }
                    }).catch(err => {
                        console.log(err);
                        sessionStorage.removeItem('data_promotion');
                        // 支付数据初始化
                        this.PayDataPre(this.$route.query.promotionCode || isUseCoupon);
                    });
            },
            //连续包月增加--20241205--start
            getValidityPeriod (a) {
                // 有效期
                let periodTxt = '';

                if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
                    periodTxt = this.getTypeOfFailures(a);      // 失效类型
                } else {
                    if (a.period == null || a.period == '') {
                        periodTxt = '';
                    } else {
                        let actionType = this.getEffectiveType (a);     // 生效类型
                        periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
                    }
                }
                return periodTxt;
            },
            getTypeOfFailures (a) {
                // 失效类型
                let actionType = '';

                if (a != null && a != '' && a.attrMap.expType) {
                    if (a.attrMap.expType == 'CURRENT_MONTH') {
                        actionType = this.$t('packages.month_invalid');
                    } else if (a.attrMap.expType == 'CURRENT_DAY') {
                        actionType = this.$t('packages.day_invalid');
                    } else if (a.attrMap.expType == 'DEFAULT') {
                        actionType = '';
                    } else {
                        actionType = '';
                    }
                }
                return  actionType;
            },
            getEffectiveType (a) {
                // 生效类型
                let actionType = '';

                if (a != null && a != '' && a.attrMap.effType) {
                    if (a.attrMap.effType == 'IMMEDIATELY') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = '('+ this.$t('packages.immediate_valid') +')'

                    } else if (a.attrMap.effType == 'MORROW') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '('+ this.$t('packages.tomorrow_day_valid') +')';

                    } else if (a.attrMap.effType == 'USER_DEFINED') {
                        actionType = '';

                    } else if (a.attrMap.effType == 'NEXT_MONTH') {
                        a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '('+ this.$t('packages.tomorrow_month_valid') +')';

                    } else {
                        actionType = '';
                    }
                }
                return actionType;
            },
            getUnitOfTime (a, b) {
                let unit = a;

                if (unit == 'DAY' || unit == null || unit == '') {
                    if (parseInt(b) < 2 || b == null || b =='') {
                        unit = this.$t('packages.periodUnit.day');
                    } else {
                        unit = this.$t('packages.periodUnits.day');
                    }
                } else if (unit == 'MONTH') {
                    if (parseInt(b) < 2 || b == null || b =='') {
                        unit = this.$t('packages.periodUnit.month');
                    } else {
                        unit = this.$t('packages.periodUnits.month');
                    }
                }
                return unit;
            },
            //moOrDay 的功能 与genHighSeepText 一致
            //新老版本使用方法不同，保留genHighSeepText方法 
            moOrDay(data){
                var str = "";
                if(data.periodUnit == 1){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnits.day');
                }else{
                    str = this.$t('packages.periodUnit.day');
                }

                }else if(data.periodUnit == 2 || data.periodUnit == 12){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnitsSimp.month');
                    }else{
                        str = this.$t('packages.periodUnitSimp.month');
                    }
                }else if(data.periodUnit == 0){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.hour');
                    }else{
                        str = this.$t('packages.periodUnit.hour');
                    }
                }else if(data.periodUnit == 3){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.year');
                    }else{
                        str = this.$t('packages.periodUnit.year');
                    }
                }else{
                    str = '';
                }
                return str;
            
            },
            preCalcOrder(data){
                let that = this;
                let package_param = {
                    userCode: JSON.parse(localStorage.getItem("userInfo"))['userCode'],
                    payMethod: "ACCOUNT_AMOUNT",
                    promotionCode:"",
                    payCurrencyType: data.currencyType,
                    payAgreeFlag: 1,
                    goodsList: [{goodsId:data.goodsId,quanity:that.quantity}]
                };
                
                return this.$http.post(this.$api.preCalcOrder, package_param);
            },
            getAgreePackage () {
                let that =this;
                let package_param = {
                    baseCode: this.urlParams.goodsCode,
                    sortFlag: 1,
                    realType: "AGREE_RECOMMOND",
                    queryLimitFlag:true,
                    queryPromotionFlag: true
                };
                return that.$http.post(this.$api.getAgreePackage, package_param).then(res=>{
                    let dataList = [];
                    dataList = (res?.data?.dataList || []).map(item => {
                        let tempNor =  item;
                        let flow;
                         if (!tempNor) {
                            return;
                        }
                        if (tempNor.categoryCode === "BTTC" || 
                            tempNor.categoryCode === "BYTC" ||
                            tempNor.categoryCode === "SWBY" || 
                            tempNor.categoryCode === "CXTC" || 
                            tempNor.categoryCode === "ZLTC") {
                            if(!!(tempNor.flowByte) && tempNor.flowByte>0){
                                flow = baseUtils.trafficRules(tempNor.flowByte)+" "+this.$t('packages.high_speed_text');
                            }else{
                                flow = this.$t('packages.infiniteFlow');
                            }
                        } else {
                            if (tempNor.goodsType == 'DISC'){
                                flow = baseUtils.trafficRules(tempNor.flowByte)+" "+this.$t('packages.highSpeedTraffic');    
                            }else{
                                flow = baseUtils.trafficRules(tempNor.flowByte);
                            }
                            
                        }
                        let high_speed_text = this.genHighSeepText(tempNor);
                        tempNor.select = false;
                        tempNor.showFlow = this.doFlowByteText(tempNor) + ' ' + high_speed_text;
                        tempNor.showPeriod = this.getValidityPeriod(tempNor);
    
                        tempNor.showPrice = this.doPriceStyle(tempNor, +tempNor.goodsPrice + '');
    
                        tempNor.mccListText = tempNor.mccList.join(SymbolMap[cookie.getCookie('langType')]||', ');
                        tempNor.showUserDetail = tempNor.attrMap.pkDesc;
                        tempNor.periodTxt = tempNor.periodUnit == 'MONTH' ? (tempNor.period > 1 ? this.$t('packages.periodUnits.month') : this.$t('packages.periodUnit.month')) : (tempNor.period > 1 ? this.$t('packages.periodUnits.day') : this.$t('packages.periodUnit.day')) ;
                        tempNor.periodStr = tempNor.goodsType==='DISC' && tempNor.billingInfos ?  this.moOrDay(tempNor.billingInfos[0]) : '' ;
                        return tempNor;
                    })
                    let orderPackage = dataList.find(item => item.goodsCode === sessionStorage.getItem('currentGoodsCode'));
                    if(orderPackage){
                        this.handlerShowOrderTips(orderPackage.goodsCode);
                    }
                    return dataList;
                });
            },
            // 获取已购买的套餐列表
            getPackageUseDetail() {
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let data = {
                        flag: 0,
                        queryNoUse: true,
                        goodsType: "ALL",
                        customerId: urlData['loginCustomerId'],
                        goodsExtendAttrs:["hideFlowSize"]
                }
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    data = {
                    ...data,
                    imei:urlData?.imei
                    }
                }
                this.$http
                    .post({
                        url: "/bss/app/orderRelation/QueryUserOfferList",
                        data: {
                            ...data
                        }
                    })
                    .then(res => {
                        if(res.data && res.data.dataList && res.data.dataList.length) {
                            // 过滤掉配置不展示的套餐
                            let codeList = checkProjectConfig.setAppThat(this).checkValue("Test_Package_Codes",[]);
                            let codeList1 = checkProjectConfig.setAppThat(this).checkValue("User_Taste_Codes",[]);
                            let dataList = res.data.dataList;
                            if(codeList && codeList.length){
                                dataList = (dataList || []).filter(item => {
                                    return !codeList.includes(item.goodsCode);
                                })
                            }

                            if(codeList1 && codeList1.length){
                                dataList = (dataList || []).filter(item => {
                                    return !codeList1.includes(item.goodsCode);
                                })
                            }
                            dataList = dataList.map(item => {
                                if(item.expiryTime || item.activeDeadline){
                                    let remainingTime = (item.expiryTime ? item.expiryTime : item.activeDeadline * 24 * 3600 * 1000 + item.createTime) - Date.now();
                                    remainingTime <= 1000 * 60 * 60 * 24 * 3 ? item.isLessThree = true : item.isLessThree = false;
                                    remainingTime <= 1000 * 60 * 60 * 24 * 30 ? item.isLessThirty = true : item.isLessThirty = false;
                                }

                                if(item.categoryCode === 'LXCX' && (item.attrMap.payAgreeFlag == '1' || item.payAgreeFlag == '1')){
                                    this.relationId = item.relationId;
                                }

                                return {
                                    ...item,
                                }
                            })
                            this.usePackageList = dataList;

                            // let packageDetail = dataList.find( item => {
                            //     return item.inUse == '1'
                            // })
                            // if(!packageDetail){
                            //     packageDetail = dataList.find( item => {
                            //         return item.status == 'VALID'
                            //     })
                            // }
                            // if(!packageDetail){
                            //     packageDetail = dataList.find( item => {
                            //         return item.status == 'NOT_ACTIVATED' || item.status == 'IN_USING'
                            //     })
                            // }
                            // //计算剩余时间、有效期
                            // let  calcActiveTime = ({ expiryTime, activeDeadline, createTime, periodUnit, period }) =>{
                            //     period = period || 0;
                            //     //有效期
                            //     if (!expiryTime && !activeDeadline) {
                            //         return {
                            //             name: this.$t("order.validPeriod"),
                            //             time: period + this.$t(`order.periodUnits.${periodUnit.toLowerCase()}`),
                            //             notRed: !(periodUnit == "DAY" && period <= 3)
                            //         };
                            //     }
                            //     //剩余时间
                            //     let remainingTime = (expiryTime ? expiryTime : activeDeadline * 24 * 3600 * 1000 + createTime) - Date.now();
                            //     let _calc = (time) => {
                            //         if (time < 0) time = 0;
                            //         //小时
                            //         let hour = time / (3600 * 1000);
                            //         if (hour < 1) return { time: Math.ceil(time / (60 * 1000)) + this.$t("order.periodUnits.minute") };
                            //         if (hour < 24) return { time: Math.ceil(hour) + this.$t("order.periodUnits.hour") };
                            //         //天
                            //         let day = Math.ceil(time / (24 * 3600 * 1000));
                            //         return {
                            //             time: day + this.$t("order.periodUnits.day"),
                            //             notRed: day > 3
                            //         };
                            //     }
                            //     return Object.assign(_calc(remainingTime), { name: this.$t("order.remainingTime") });
                            // }

                            // //查询的销售品扩展属性列表
                            // function goodsExtendAttrs(item,{extendValVos}) {
                                
                            //     if(extendValVos && extendValVos.length){
                            //         extendValVos.forEach( _goodsExtendAttrsItem => {  
                            //             // 获取 attrValueList 数组  
                            //             const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                                        
                            //             // 判断attrValueList数组并获取值  
                            //             const getValue= attrValueList && attrValueList[0];

                            //             //a_hideFlowSize
                            //             item['a_'+_goodsExtendAttrsItem.attrCode] = attrValueList;

                            //             //a_getValue_hideFlowSize
                            //             item['a_getValue_'+_goodsExtendAttrsItem.attrCode] = getValue;
                            //         });
                                    
                            //     }
                            // }
                            // if(packageDetail){
                            //         //优惠销售品
                            //         if (packageDetail.goodsType == "DISC") {
                            //             let da = packageDetail.accumulatedFlowList;
                            //             da = (da && da[0]) || { totalFlow: "", accumulatedFlow: "" };
                            //             let calculateFlow = this._math().sub(da.totalFlow, da.accumulatedFlow);
                            //             calculateFlow = calculateFlow > 0 ? calculateFlow : 0;
                            //             packageDetail.a_surplusFlow = { type: "DISC", flow: da.totalFlow, remainFlow: calculateFlow };
                            //         }
                            //         //流量包
                            //         if (packageDetail.goodsType == "PKAG") packageDetail.a_surplusFlow = { type: "PKAG", flow: packageDetail.flowByte, remainFlow: packageDetail.surplusFlowbyte };

                            //         packageDetail.a_activeTime = calcActiveTime(packageDetail);

                            //         goodsExtendAttrs(packageDetail,packageDetail);

                            //         this.packageUseDetail = packageDetail;

                            //         setTimeout(() => {
                            //             this.$refs?.NewHome?.setUseStyle();
                            //         }, 300);
                            // } else {
                            // }
                        } else {
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            //连续包月增加--20241205--end
            getMccListText() {
                this.getCoverListMixin().then(res => {                    
                    let mccMap = {};
                    this.detail.iso2List.forEach(iso => {
                        res.data.forEach(obj => {
                            if(iso == obj.iso2 && obj.continent) {
                                if(mccMap[obj.continent]) {
                                    mccMap[obj.continent].push(obj.countryName)
                                } else {
                                    mccMap[obj.continent] = [];
                                    mccMap[obj.continent].push(obj.countryName)
                                }
                            }
                        })
                    });                    
                    let text = '';
                    Object.keys(mccMap).forEach(key => {
                        text += `${key}：${mccMap[key].join('、')}<br/>`
                    });
                    this.mccListText = text;
                }).catch(err => {
                    this.$toast(err)
                })
            },
            genHighSeepText(item) {
                if (item.goodsType == 'DISC') { // unlimited packages
                    if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                        // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
                        // 有限期和限速规则一样，显示高速流量
                        let billInfo = item.billingInfos;
                        if(billInfo && billInfo.length > 0) {
                            if(billInfo[0].periodUnit === 0) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                                    }
                                }
                            } else if(billInfo[0].periodUnit === 1) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                                item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.day')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                                    }
                                }

                            } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                                    }
                                }
                            } else if(billInfo[0].periodUnit === 3) {
                                if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                                    item.high_speed_text = this.$t('packages.high_speed_text');
                                } else {
                                    if(billInfo[0].period > 1) {
                                        item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                                    } else {
                                        item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                                    }
                                }
                            }
                        }
                    }
                }

                return item.high_speed_text ? item.high_speed_text : '';
            },
            doFlowByteText(item) {
                let flowText = '0MB',
                    flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

                if(flowValue >= 1000) {
                    let flow = flowValue/1024;
                    // 判断是不是整数
                    if(Math.floor(flow) === flow) {
                        flowText = `${flow}GB`;
                    } else {
                        let langType = cookie.getCookie('langType')
                        // 部分欧洲国家小数点采取 ， 形式
                        let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                        let showFlow = keepTwodecimalFixed(flow)
                        if(country.includes(langType)){
                            showFlow = showFlow.replace('.',',')
                        }
                        flowText = `${showFlow}GB`;
                    }
                } else {
                    flowText = `${flowValue}MB`;
                }

                return flowText;        
            },
            doPriceStyle(item, price) {
                //price = keepTwodecimalFull(price/100);
                //return `${item.currencyType} ${price}`;
                return this.globalPriceFormat(item.currencyType, price);                
            },
            goodsExtendAttrs(item,{extendValVos}){
                if(extendValVos && extendValVos.length){
                    let _item = arguments[0];
                    extendValVos.forEach( _goodsExtendAttrsItem => {  
                        // 获取 attrValueList 数组  
                        const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                          
                        // 判断attrValueList数组并获取值  
                        const getValue= attrValueList && attrValueList[0];

                        //a_hideFlowSize
                        item['a_' + _goodsExtendAttrsItem.attrCode] = attrValueList;

                        //a_getValue_hideFlowSize
                        item['a_getValue_' + _goodsExtendAttrsItem.attrCode] = getValue;

                    });
                    return _item;
                }
            },
            // 判断是否使用了货币符号
            isCurrencySymbol(price='') {
                let typeList = [];
                if(this.$APP_CONFIG.currencyTypeMap) {
                    typeList = Object.keys(this.$APP_CONFIG.currencyTypeMap);
                }
                return typeList.some(item => {
                    return price?.toLowerCase()?.includes(item) && this.$APP_CONFIG.currencyTypeMap[item];
                })
            },
        }
    }
</script>

<style lang="less" scoped>    
    @import 'css/detail.less';
    @assets: "../../assets";
    ::v-deep {
    .flex2{
        flex:2;
    }
    .goods-price i.oprice {
        opacity: 0.8;
        font-size: .28rem;
        color: #999999;
        text-decoration: line-through;
    }
    .se_package_option .se_package_price {
        font-size: 0.36rem;
        color: #F74E4E;
        margin-bottom: 0.05rem;
    }
    .se_package_option .continue_mo,
    .se_package_option .normal_mo  {
        border: 0.5px solid rgba(224,224,224,1);
        padding: 0.2rem;
        border-radius: 0.08rem;
        margin: 0 0 12px;
    }
    .se_package_option {
        background: #ffffff;
        border-radius: 8px;
        padding: 12px 12px 1px;
        margin-top: 0.16rem;
    }
    .se_package_option .se_title{
        font-size: 0.30rem;
        color: #333333;
        margin-bottom: 0.26rem;
        font-weight: 600;
    }
    .se_package_option .continue_mo.active{
        border: 1px solid rgba(255,179,50,1);
    }
    .se_package_option .se_content{
        margin: .18rem 0;
    }
    .se_package_option .se_content{
        font-size: 0.28rem;
        color: #333333;
    }
    .se_package_price i.oprice {
        opacity: 0.8;
        font-size: .28rem;
        color: #999999;
        text-decoration: line-through;
    }
    .se_package_option .active{
        background:url("@{assets}/imgs/packages/op_selected_right.png") no-repeat rgba(255,179,50,0.10) top right;
        background-size: 0.6rem;
    }
    }
</style>